import React from "react";

/**
 * Value color per tone. Full class strings retained.
 * @type {Record<string, string>}
 */
const VALUE_TONE_CLASSES = {
  neutral: "text-gray-800",
  danger: "text-danger-dark",
  success: "text-success",
};

/**
 * Compact metric card with a large value, uppercase label, and optional sub line.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.label - Uppercase metric label.
 * @param {React.ReactNode} props.value - Prominent metric value.
 * @param {'neutral'|'danger'|'success'} [props.tone='neutral'] - Value color tone.
 * @param {React.ReactNode} [props.sub] - Optional secondary line.
 */
export const MetricCard = ({ label, value, tone = "neutral", sub }) => {
  const valueClass = VALUE_TONE_CLASSES[tone] || VALUE_TONE_CLASSES.neutral;

  return (
    <div className="bg-white rounded-xl shadow-md p-4">
      <p className={`text-2xl font-bold ${valueClass}`}>{value}</p>
      <p className="text-xs text-gray-500 tracking-wide uppercase mt-1">{label}</p>
      {sub && <p className="text-xs text-gray-400 mt-1">{sub}</p>}
    </div>
  );
};
